import { FC } from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { makeStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles';

import orchidImg from '../images/orchid_404.png';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            height: "100vh",
            width: "100%",
            background: "#FBDAF5",
            color: "#001B2E",
        },
        insideContainer: {
            height: "50vh",
            display: "flex",
            alignItems: "center",
            justifyItems: "center",
        },
        errorImage: {
            paddingTop: 20,
            paddingBottom: 20,
            paddingRight: 40,
            paddingLeft: 20,
        },
        errorText: {
            paddingTop: 20,
            paddingBottom: 20,
            paddingRight: 20,
            paddingLeft: 40,
            borderLeft: "1px solid #001B2E",
        },
    })
);

const containerSX = {
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    height: "100%",
}

const NoPageFound: FC = () => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Container sx={containerSX}>
                <div className={classes.insideContainer}>
                    <div className={classes.errorImage}>
                        <img alt="Angry Orchid 404" src={orchidImg} />
                    </div>
                    <div className={classes.errorText}>
                        <Typography variant="h2">404</Typography>
                        <Typography variant="subtitle1">Go away, there's nothing here!</Typography>
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default NoPageFound;